import reducer from "./reducer";
export { default as MyPeopleSchedule } from "./components/index";
export { default as myPeopleScheduleReducerName } from "./constants";
export default reducer;
